// Datos estructurados globales del sitio (fuente única de verdad).
// Organization vive en __root (sitewide); LocalBusiness/ProfessionalService
// solo en la home y en las landings locales.

export const SITE_URL = "https://agenciaseoevolution.com";

export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const LOCALBUSINESS_ID = `${SITE_URL}/#localbusiness`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  name: "SEOEVOLUTION",
  legalName: "SEOEVOLUTION SL",
  description:
    "Agencia SEO y GEO premium especializada en inteligencia artificial, SEO local, ecommerce y desarrollo web en React.",
  url: `${SITE_URL}/`,
  logo: {
    "@type": "ImageObject",
    url: `${SITE_URL}/logo.png`,
  },
  email: "contacto@agenciaseoevolution.com",
  telephone: "+34910626684",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Madrid",
    addressRegion: "Comunidad de Madrid",
    addressCountry: "ES",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+34910626684",
    email: "contacto@agenciaseoevolution.com",
    contactType: "customer service",
    areaServed: "ES",
    availableLanguage: ["Spanish"],
  },
  sameAs: ["https://www.instagram.com/agencia_seoevolution"],
  foundingDate: "2024",
  slogan: "SEO Inteligente, Resultados Reales",
  founder: {
    "@type": "Person",
    name: "Ángel Ruz Serrano",
    jobTitle: "CEO & Director",
  },
  areaServed: { "@type": "Country", name: "España" },
  knowsAbout: [
    "SEO Local",
    "SEO para E-commerce",
    "SEO Web",
    "Inteligencia Artificial aplicada al SEO",
    "GEO (Generative Engine Optimization)",
    "Google Maps Optimization",
    "Link Building",
    "SEM con IA",
    "Desarrollo Shopify",
    "Desarrollo React",
    "Google Merchant Center",
    "Gestión de Reseñas",
  ],
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": LOCALBUSINESS_ID,
  name: "SEOEVOLUTION",
  description:
    "Agencia SEO y GEO en Madrid: posicionamiento web con IA, SEO local, ecommerce y webs en React. Plazas limitadas por zona.",
  url: `${SITE_URL}/`,
  image: `${SITE_URL}/logo.png`,
  logo: `${SITE_URL}/logo.png`,
  parentOrganization: { "@id": ORGANIZATION_ID },
  telephone: "+34910626684",
  email: "contacto@agenciaseoevolution.com",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Madrid",
    addressRegion: "Comunidad de Madrid",
    addressCountry: "ES",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 40.4168,
    longitude: -3.7038,
  },
  areaServed: [
    { "@type": "City", name: "Madrid" },
    { "@type": "City", name: "Barcelona" },
    { "@type": "City", name: "Valencia" },
    { "@type": "Country", name: "España" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "10:00",
      closes: "17:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Friday"],
      opens: "10:00",
      closes: "14:00",
    },
  ],
  sameAs: ["https://www.instagram.com/agencia_seoevolution"],
};

export interface Crumb {
  name: string;
  /** Ruta relativa, p. ej. "/blog" o "/servicios/seo-local-ia". La home se añade sola. */
  path: string;
}

/** BreadcrumbList canónico. Siempre arranca en Inicio y usa URLs absolutas. */
export function buildBreadcrumb(crumbs: Crumb[]) {
  const items = [{ name: "Inicio", path: "/" }, ...crumbs];
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: c.path === "/" ? `${SITE_URL}/` : `${SITE_URL}${c.path}`,
    })),
  };
}

/** Helper para el array `scripts` de head(). */
export function ldJson(schema: unknown) {
  return { type: "application/ld+json", children: JSON.stringify(schema) };
}
